"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.combineDecorators = void 0;
/**
 * Util to combine several decorators to be applied to a class.
 *
 * @example
 * // Create AccountId decorator.
 * // NOTE: Do not forget to execute the wrapper function (just adding IsString will have no effect, while IsString() does)
 * export const AccountId = () => combineDecorators(IsString(), IsNumeric(), ExactLength(10));
 *
 * @param decorators Decorators to combine.
 * @returns combined decorator
 */
const combineDecorators = (...decorators) => (target, key) => {
    decorators.forEach((decorator) => {
        decorator(target, key);
    });
};
exports.combineDecorators = combineDecorators;
